import Vue from 'vue'
import Vuex from 'vuex'
import account from './modules/account'
import router from './modules/router'
import servicePack from './modules/service-pack'

Vue.use(Vuex)

export default new Vuex.Store({
	strict: true,
	state: {},
	mutations: {},
	actions: {},
	modules: {
		account,
		router,
		servicePack
	}
})
